if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[id^="ProductSubmitButton-"]');
        this.ingredientPanels = [];

        this.querySelectorAll('.product-panel').forEach((panel) => {
            const toggleButton = panel.querySelector('[aria-controls]');
            if (!toggleButton) return;

            const content = panel.querySelector('.product-panel__content');
            if (panel.dataset.ingredientCharacterLimit && content) {
                const update = () => {
                    const text = content.textContent.replace(/\s+/g, ' ').trim();
                    const limit = Number(panel.dataset.ingredientCharacterLimit);
                    const expanded = text.length > 0 && text.length <= limit ? 'true' : 'false';
                    toggleButton.setAttribute('aria-expanded', expanded);
                    panel.dataset.expanded = expanded;
                };
                const observer = new MutationObserver(update);
                this.ingredientPanels.push({ content, update, observer });
            }

            toggleButton.addEventListener('click', () => {
                const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
                const nextExpanded = isExpanded ? 'false' : 'true';

                toggleButton.setAttribute('aria-expanded', nextExpanded);
                panel.dataset.expanded = nextExpanded;
            });
        });

        this.querySelector('#increase-quantity')?.addEventListener('click', (e) => {
            const quantity = this.querySelector('#quantity');
            quantity.value = parseInt(quantity.value) + 1;
        });

        this.querySelector('#decrease-quantity')?.addEventListener('click', (e) => {
            const quantity = this.querySelector('#quantity');
            if (parseInt(quantity.value) > 1)
                quantity.value = parseInt(quantity.value) - 1;
        });

        
        this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.ingredientPanels.forEach(({ content, update, observer }) => {
          update();
          observer.observe(content, { childList: true, subtree: true, characterData: true });
        });
      }

      disconnectedCallback() {
        this.ingredientPanels.forEach(({ observer }) => observer.disconnect());
      }

      setSubmitButtonLoading(isLoading) {
        if (!this.submitButton) return;
        this.submitButton.classList.toggle('is-loading', isLoading);
        this.submitButton.toggleAttribute('disabled', isLoading);
        this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton?.classList.contains('is-loading')) return;
        this.setSubmitButtonLoading(true);

        try {
          if (window.addToCartHandler) {
            await window.addToCartHandler(this.form);
            return;
          }

          // Fallback: direct form submission if cart drawer JS hasn't loaded
          this.form.submit();
        } catch (error) {
          console.error(error);
        } finally {
          if (window.addToCartHandler) {
            this.setSubmitButtonLoading(false);
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
